<section class="page-hero how-hero">
  <div class="hero-copy">
    <p class="eyebrow">How it works</p>
    <h1>A clear path from application to tracked commission.</h1>
    <p class="lede">The ambassador flow is designed to be easy to explain, simple to track, and aligned with the way marine professionals already recommend tools to customers.</p>
    <div class="cta-row">
      <a class="button-link" routerLink="/signup">Start your application</a>
      <a class="button-link secondary" routerLink="/commission-plans">View commission plans</a>
    </div>
  </div>
</section>

<section class="content-section process-section">
  <div class="section-heading">
    <p class="eyebrow">Process</p>
    <h2>Six steps, no mystery.</h2>
  </div>
  <ol class="process-flow">
    <li><span>01</span><strong>Apply</strong><p>Create your account and tell YachtApp how you plan to promote the product.</p></li>
    <li><span>02</span><strong>Get reviewed</strong><p>The program team confirms fit, channel quality, and any market-specific terms.</p></li>
    <li><span>03</span><strong>Receive tools</strong><p>Approved ambassadors get a referral link plus campaign materials such as QR codes or promo assets.</p></li>
    <li><span>04</span><strong>Share YachtApp</strong><p>Introduce the platform in relevant conversations, content, marina materials, or customer onboarding.</p></li>
    <li><span>05</span><strong>Track subscriptions</strong><p>Eligible signups are attributed through approved links, codes, and defined attribution rules.</p></li>
    <li><span>06</span><strong>Get paid</strong><p>Approved commissions are reviewed after billing and refund checks, then paid on the program schedule.</p></li>
  </ol>
</section>

<section class="content-section">
  <div class="section-heading">
    <p class="eyebrow">Tracking and payouts</p>
    <h2>Built to be transparent for partners and customers.</h2>
  </div>
  <div class="feature-grid">
    <article><span class="feature-icon">Link</span><h3>Referral links</h3><p>Each approved ambassador receives a unique link that identifies traffic and eligible signups.</p></article>
    <article><span class="feature-icon">Code</span><h3>Promo codes</h3><p>Approved codes help customers recognize your offer and give YachtApp another attribution signal.</p></article>
    <article><span class="feature-icon">Time</span><h3>Attribution window</h3><p>When a prospect clicks your link, YachtApp keeps a defined window for eligible subscription attribution.</p></article>
    <article><span class="feature-icon">MRR</span><h3>Recurring commissions</h3><p>Recurring plans reward ambassadors while referred subscriptions remain active and eligible.</p></article>
    <article><span class="feature-icon">Pay</span><h3>Payout schedule</h3><p>Commissions are reviewed after billing and refund checks, then paid monthly once minimum payout rules are met.</p></article>
  </div>
</section>

<section class="content-section join-panel compact">
  <p class="eyebrow">Ready to begin?</p>
  <h2>Set up your ambassador profile in a few minutes.</h2>
  <a class="button-link" routerLink="/signup">Apply now</a>
</section>
